import { CustomPaletteOptions } from './types'

export const palette = (mode: 'dark' | 'light'): CustomPaletteOptions => ({
  mode,
  common: {
    white: '#FFFFFF',
  },
  black: {
    main: '#222221',
    '70': 'rgba(34,34,33, 0.7)',
    '50': 'rgba(34,34,33, 0.5)',
    '20': 'rgba(34,34,33, 0.2)',
  },
  yellow: {
    main: '#EED484',
    '70': 'rgba(238, 212, 132, 0.7)',
    '50': 'rgba(238, 212, 132, 0.5)',
    '20': 'rgba(238, 212, 132, 0.2)',
  },
  warmGrey: {
    main: '#8B8178',
    '70': 'rgba(139,129,120, 0.7)',
    '50': 'rgba(139,129,120, 0.5)',
    '20': 'rgba(139,129,120, 0.2)',
  },
  lightBlue: {
    main: '#8E9FBC',
    '70': 'rgba(142,153,188, 0.7)',
    '50': 'rgba(142,153,188, 0.5)',
    '20': 'rgba(142,153,188, 0.2)',
  },
  blue: {
    main: '#135193',
    '70': 'rgba(19,81,147, 0.7)',
    '50': 'rgba(19,81,147, 0.5)',
    '20': 'rgba(19,81,147, 0.2)',
  },
  darkBlue: {
    main: '#1B365D',
    '70': 'rgba(27,54,93, 0.7)',
    '50': 'rgba(27,54,93, 0.5)',
    '20': 'rgba(27,54,93, 0.2)',
  },
  green: {
    main: '#00685E',
    '70': 'rgba(0,104,94, 0.7)',
    '50': 'rgba(0,104,94, 0.5)',
    '20': 'rgba(0,104,94, 0.2)',
  },
  red: {
    main: '#A6192E',
    '70': 'rgba(166, 25, 46, 0.7)',
    '50': 'rgba(166, 25, 46, 0.5)',
    '20': 'rgba(166, 25, 46, 0.2)',
  },
  background: {
    paper: '#F2F2F2',
  },
})
